import { Row } from "@/components/Row";

import { cn } from "@/lib/utils";

// Three dots taking turns, the way a phone shows someone typing.
export const SadieSimulatorTypingDots = ({
  className,
}: {
  className?: string;
}) => (
  <Row className={cn("h-6 items-center gap-1 self-start", className)}>
    {[0, 1, 2].map((i) => (
      <span
        className="h-1.5 w-1.5 animate-bounce rounded-full bg-slate-400"
        key={i}
        style={{ animationDelay: `${String(i * 150)}ms` }}
      />
    ))}
  </Row>
);
